import { layoutTypes } from '../types';

export const asideChange = (isOpen: boolean): { type: string; payload: boolean } => ({
  type: layoutTypes.CHANGE_ASIDE_MENU,
  payload: isOpen
});
